import { AnyFeedItemEntityVersion, FeedItem, Logger } from '@uploadcam/common';
import { CollectionReference, doc, updateDoc } from 'firebase/firestore';
import { StorageProvider } from '../../../storage/storage.provider';
import { MockItem } from '../../../storage/data/common/mock.item';

interface UpdateFeedItemData {
  caption?: string;
  tags?: string[];
}

export class UpdateFeedItemInteractor {
  constructor(
    private readonly collection: CollectionReference<AnyFeedItemEntityVersion>,
    private readonly logger: Logger,
    private readonly storageProvider: StorageProvider,
  ) {}

  public async execute(feedItem: FeedItem, data: UpdateFeedItemData): Promise<void> {
    const docRef = doc(this.collection, feedItem.id);
    const caption = data.caption !== undefined ? { caption: data.caption.trim() || null } : {}; // Don't replace with `??` so empty (falsy) strings are handled
    const tags = data.tags !== undefined ? { tags: data.tags } : {};

    await updateDoc(docRef, {
      ...caption,
      ...tags,
    });

    try {
      // Best effort, don't block on failure
      const manager = await this.storageProvider.provideManager();
      await manager.setCaption(MockItem.fromFeedItem(feedItem), caption.caption ?? undefined);
    } catch (err) {
      this.logger.warn('Failed to update caption in storage', err);
    }
  }
}
